import React, { useEffect, useRef } from "react";
import { Close } from "../../../assets/icons";
import Success from "../../../assets/icons/Success";
import Error from "../../../assets/icons/Error";

interface NotificationProps {
    type: "success" | "error" | "warning" | "info" | string;
    message: string;
    onClose: () => void;
    isOpen: boolean;
    timeout?: number;
    width?: string;
}

const Notification: React.FC<NotificationProps> = ({
    type,
    message,
    onClose,
    isOpen,
    timeout = 2000,
    width
}) => {
    const notificationRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            const autoCloseTimer = setTimeout(() => {
                onClose();
            }, timeout);

            return () => {
                clearTimeout(autoCloseTimer);
            };
        }
    }, [isOpen, onClose, timeout]);

    return (
        <>
            {isOpen && (
                <div
                    className={`flex items-center space-x-4 rounded-lg border shadow-lg transition-all p-4 ${width ? `w-${width}` : 'w-[300px]'} ${type === "success" ? "bg-success-600 border-success-600" : ""
                    } ${type === "error" ? "bg-error-600 border-error-600" : ""} ${type === "warning" ? "bg-warning-600 border-warning-600" : ""
                    } ${type === "info" ? "bg-primary-600 border-primary-600" : ""
                    }`}
                    ref={notificationRef}
                >
                    <div className="flex-shrink-0">
                        {type === "success" ? <Success /> : <Error />}
                    </div>
                    <div className="flex-1 text-neutral-25 text-[14px] font-bold">
                        {message}
                    </div>
                    <Close className="cursor-pointer" onClick={onClose} />
                </div>
            )}
        </>
    );
};

export default Notification;
